export enum InfoTooltipVariant {
    Info = 'info',
    Warning = 'warning',
}
